import PlusCircle from "@/assets/icons/plus-circle.svg";
import { Button } from "@/components/ui/button";
import {
    Tooltip,
    TooltipContent,
    TooltipProvider,
    TooltipTrigger,
} from "@/components/ui/tooltip";
import { useContextBarAppearance } from "@/contexts/ContextBarAppearanceContext";
import TodoItem from "@/domain/entities/TodoItem";
import { cn } from "@/lib/utils";
import { useTranslation } from "react-i18next";

type TodoProposedLineProps = {
    todo: TodoItem;
    handleAcceptTodo: (todo: TodoItem) => void;
};

const TodoProposedLine = ({
    todo,
    handleAcceptTodo,
}: TodoProposedLineProps) => {
    const { t } = useTranslation();
    const { isDeepFocus } = useContextBarAppearance();

    return (
        <div
            className={cn(
                "flex items-center gap-2 rounded-sm px-1 hover:bg-surface-primary",
                isDeepFocus && "hover:bg-white/10",
            )}
        >
            <span
                className={cn(
                    "text-left text-text-subtitle",
                    isDeepFocus && "text-white",
                )}
            >
                {todo.taskSummary}
            </span>
            <TooltipProvider delayDuration={100}>
                <Tooltip>
                    <TooltipTrigger asChild>
                        <Button
                            className="ml-auto min-w-8 hover:bg-surface-textArea/25"
                            onClick={(e) => {
                                e.stopPropagation();
                                handleAcceptTodo(todo);
                            }}
                            size="smallCircle"
                            variant="invisible"
                        >
                            <img alt="" className="h-4 w-4" src={PlusCircle} />
                        </Button>
                    </TooltipTrigger>
                    <TooltipContent>{t("todo.acceptTask")}</TooltipContent>
                </Tooltip>
            </TooltipProvider>
        </div>
    );
};

export default TodoProposedLine;
